import { colors2, getVal, MetaBlockV2, TooltipV2, UI_CAPTION, UI_CAPTION_SEMIBOLD, UI_TAG } from "oolib";
import React, { useRef } from "react";
import LexicalTextEditor from "../../../../inputs/TextEditor/LexicalTextEditor";
import { uiContent } from "../../uiContent";
import { StyledCardShell, StyledClampedTitle, StyledInfoSection } from "./styled";
import { useGetContribution } from "../../../../../utils/react-query-hooks/contributions";
import { TagSectionOnCard } from "./comps/TagSectionOnCard";
import { applyTagsWhitelistConfig } from "../../utils/applyTagsWhitelistConfig";
import { __GetContentTypeConfigNew } from "@/utils/getters/gettersV2";
import mixpanel from "mixpanel-browser";
import { useGetQueryData } from "@/utils/react-query-hooks/general";
import { MIXPANEL_EVENTS_NAMING } from "@/mixpanel/MIXPANEL_EVENTS_NAMING";
import { extractAllBlocksFromTpl, getRoutePathToPublishedContent } from "@okf/ootils";

// const { IndiaFlag } = icons;

// const flagsMap = {
//   "india" : IndiaFlag
// }


/**
 * cardConfigs: `disableTagsSection`, `disableTitleSection`, `metaBlock` ([] hides it).
 * mixpanelContext: extra properties on the card-click event — where the card was
 * shown (a report, a widget). The event's own fields are not overridable.
 */
export const CardAnnoExplorer = ({ singleAnno, lastCardObserverRef, cardConfigs, scrollIntoViewElemIdOverride, cardShellStyle, mixpanelContext }) => {
  // const FlagIcon = flagsMap[singleAnno.tags.country.data[0].tagId]  
  const { annoTags, tags } = applyTagsWhitelistConfig({annoDoc: singleAnno, cardConfigs})
  const colors = singleAnno?.fills?.length > 0 ? singleAnno?.fills : [];
  const tplConfig = __GetContentTypeConfigNew(getVal(singleAnno, "meta.contentType"));
  const contentTypeDisplay = tplConfig?.general?.content?.title || singleAnno.meta.contentType;
  const blockValuePath = singleAnno.meta?.valuePath;
  const blockProps = blockValuePath && tplConfig
    ? extractAllBlocksFromTpl({ tpl: tplConfig }).find(b => b.valuePath === blockValuePath)?.props
    : undefined;
  const blockLabel = blockProps?.shortLabel || blockProps?.label;
  const platformConfigs = useGetQueryData('platformConfigs');
  const { SELF_MANAGED_BASE_CONFIGS } = platformConfigs;
  const shouldGroupBySubTheme = (
    SELF_MANAGED_BASE_CONFIGS?.enable === true ||
    platformConfigs?.deployment?._AnnotationFramework?.framework === 'tags_subThemes_themes'
  );

  const contentType = singleAnno.meta.contentType || singleAnno.meta.kp_content_type;
  const contentId = singleAnno.meta.documentId;

  const href = getRoutePathToPublishedContent({ contentType, contentId, SELF_MANAGED_BASE_CONFIGS, scrollIntoViewElemId: scrollIntoViewElemIdOverride || singleAnno.annotations.annoKey })

  return (
    <a
      target="_blank"
      href={href}
      onClick={() => {
        mixpanel.track(MIXPANEL_EVENTS_NAMING.CARD_CLICKED.eventName, {
          ...mixpanelContext,
          "Feature": 'Annotation Explorer',
          [MIXPANEL_EVENTS_NAMING.CARD_CLICKED.properties.CONTENT_TYPE] : contentTypeDisplay,
          [MIXPANEL_EVENTS_NAMING.CARD_CLICKED.properties.CONTENT_TITLE]: singleAnno.main.title,
          [MIXPANEL_EVENTS_NAMING.CARD_CLICKED.properties.ANNOTATION]: singleAnno.annotations?.fragment?.allText?.length > 400
            ? singleAnno.annotations.fragment.allText.substring(0, 400) + '...'
            : singleAnno.annotations?.fragment?.allText
        })
      }}
    >
     
      <StyledCardShell
        key={singleAnno._id + singleAnno.annotations.annoKey}
        lastCardObserverRef={lastCardObserverRef}
        // className={singleAnnoI === thisAry.length - 1 && 'has ref'}
        ref={lastCardObserverRef}
        style={cardShellStyle}
      >
        <StyledInfoSection colors={colors} $hasTagSection={!cardConfigs?.disableTagsSection}>
          
          {/* Content type title */}
          <div style={{ display: 'flex', justifyContent: "space-between" }}> {/* Temp height as there is no icon */}
            <UI_TAG style={{ color: colors2.grey50 }}>{contentTypeDisplay}</UI_TAG>
            {/* {FlagIcon && <FlagIcon size={20} /> } */}
          </div>

          {/* Single anno lex */}
          <div style={{ color: colors2.grey80, pointerEvents: "none" }}>
            <LexicalTextEditor variant={"simple"} style={{ color: colors2.grey80, margin: 0 }} value={singleAnno.annotations.fragment} readOnly disableAnnoColors={true} annotation={false}/>
          </div>
          
          {/* title */}
          {!cardConfigs?.disableTitleSection && (
            <TooltipV2 text={`${singleAnno.main.title}${blockLabel ? ` > ${blockLabel}` : ''}`} placement="bottom">
              <StyledClampedTitle>
                <UI_CAPTION_SEMIBOLD style={{ color: colors2.grey60 }}>
                  {singleAnno.main.title}{blockLabel ? ` > ${blockLabel}` : ''}
                </UI_CAPTION_SEMIBOLD>
              </StyledClampedTitle>
            </TooltipV2>
          )}

          {/* Meta Block */}
          {
            /**
             * what this means is, 
             * 
             * if metablock configs aren't defined at all, render it with default configs.
             * 
             * if however the configs explicitly define metablock configs as an empty array,
             * then that means we shouldnt render this at all.
             * 
             */
            (!cardConfigs?.metaBlock || cardConfigs?.metaBlock.length !== 0) &&
            <MetaBlockV2 
              data={singleAnno}
              config={cardConfigs?.metaBlock || [
                { key: "date", valuePath: "updatedAt"},
                { key: "name", valuePath: "annotations.author.name"}
              ]}
              />
          }
            
          
        </StyledInfoSection>

        {!cardConfigs?.disableTagsSection ?
          <TagSectionOnCard
            {...{
              annoTags: singleAnno.annotations.tags,
              annoTagsTitle: cardConfigs?.annoTagsTitle || uiContent.annoTagsTitle,
              tags,
              tagsTitle: cardConfigs?.tagsTitle || uiContent.tagsTitle,
              contentTypeDisplay,
              contentTitle: singleAnno.main.title,
              SELF_MANAGED_BASE_CONFIGS,
              shouldGroupBySubTheme,
              // cardWidth: annoCardRef?.current?.getBoundingClientRect().width,
            }}
            />
        :null}
      </StyledCardShell>
    </a>
  );
};
